import { clearAllChat } from '@/lib/utils'

interface LogoIconProps {
  className?: string
  showBottom?: boolean
}

const LogoIcon = ({ className }: LogoIconProps) => {
  return (
    <a
      href="/"
      onClick={clearAllChat}
      className={`flex items-center gap-1 flex-row`}
    >
      <img
        alt="Logo"
        src="/logo.png"
        className={`w-11 cursor-pointer ${className}`}
      />
      <span className="h-4 w-auto rounded-full bg-red-500 px-2 text-center text-[10px] font-semibold leading-normal text-white">
        BETA
      </span>
    </a>
  )
}

export default LogoIcon
